export default "__VITE_ASSET__06P8Ba57__"